const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:2000';

const api = {
  baseURL: API_BASE_URL,
  
  // Helper function to construct full URL
  getUrl: (endpoint) => {
    return `${API_BASE_URL}/${endpoint}`;
  },
  
  // Helper function to construct image URL
  getImageUrl: (path) => {
    if (!path) return '';
    // Handle both string and array inputs
    const imagePath = Array.isArray(path) ? path[0] : path;
    // Check if imagePath exists and is a string before calling replace
    if (typeof imagePath !== 'string') return '';
    // Normalize path and construct full URL
    return `${API_BASE_URL}/${imagePath.replace(/\\\//g, '/')}`;
  }
};

export default api;